
export const pollingCount = 5;
export const pollingDelay = 1000;
